'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadScript = loadScript;
exports.isMobile = isMobile;
exports.introduceNoCaptcha = introduceNoCaptcha;
exports.getUmidToken = getUmidToken;
exports.checkEmail = checkEmail;
exports.checkPassword = checkPassword;
exports.sendPost = sendPost;

var _zoroRequest = require('@alife/zoro-request');

var _zoroRequest2 = _interopRequireDefault(_zoroRequest);

var _util = require('../../util');

var _zoroArms = require('@alife/zoro-arms');

var _zoroArms2 = _interopRequireDefault(_zoroArms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 加载js方法
function loadScript(url, dataEnv) {
    return (0, _zoroRequest2.default)({
        type: 'script',
        url: url,
        attrs: dataEnv ? {
            'data-env': 'us'
        } : undefined
    });
}

function isMobile() {
    return (/(iPhone|Android)/i.test(navigator.userAgent)
    );
}

var isLoadCaptcha = false;

// 不同端， 引用不同的安全产品
function introduceNoCaptcha() {
    if (isLoadCaptcha) {
        // 保证该逻辑只执行一遍
        return;
    }
    isLoadCaptcha = true;
    if (isMobile()) {
        loadScript('//aeis.alicdn.com/sd/nch5/index.js?t=2015052012');
    } else {
        loadScript('//aeis.alicdn.com/sd/ncpc/nc.js?t=2015052012');
    }
}

// 获取ua和umidtoken
// ctl/ctl.js 这种方案目前已经不再维护，有新的接入方式
// 老的文档: http://docs.alibaba-inc.com/pages/viewpage.action?pageId=487396928
// 新的接入文档: https://yuque.antfin-inc.com/awsc/docs/mgkc1e
// getUmidtoken 方法
function getUmidToken() {
    return loadScript('//g.alicdn.com/sd/ctl/ctl.js', true);
}

/**
 * 检查邮箱地址
 * @param {string} email
 */
function checkEmail(email) {
    if (!email) {
        return false;
    }
    // var r1 = /^\s*\w+(?:\.{0,1}[\w-]+)*@[a-zA-Z0-9]+(?:[\-.][a-zA-Z0-9]+)*\.[a-zA-Z]+\s*$/i;
    var r1 = /^\w+(?:\.{0,1}[\w-]+)*@[a-zA-Z0-9]+(?:[-.][a-zA-Z0-9]+)*\.[a-zA-Z]+$/i;
    var r2 = /^((?!@(?:.*)alibaba|aliexpress|taobao|alipay).)*$/i; // 邮箱后缀不能包括aliexpress、alibaba、taobao、alipay
    if (email.length > 128) {
        // 前端email注册格式错误打点
        (0, _util.clickDot)({
            buttonType: 'register_email_format_error_front',
            objectType: 'input_box'
        });
        return false;
    } else if (r1.test(email) && r2.test(email)) {
        // 前端邮箱校验通过
        (0, _util.clickDot)({
            buttonType: 'register_email_do_creat',
            objectType: 'input_box'
        });
        return true;
    } else {
        // 前端email注册格式错误打点
        (0, _util.clickDot)({
            buttonType: 'register_email_format_error_front',
            objectType: 'input_box'
        });
        return false;
    }
}

function checkPassword(password) {
    var r = /^[\w]{6,20}$/;
    if (password.length < 6 || password.length > 20) {
        // 前端校验密码格式错误
        (0, _util.clickDot)({
            buttonType: 'register_password_format_error_front',
            objectType: 'input_box'
        });
        return false;
    } else if (r.test(password)) {
        return true;
    } else {
        // 前端校验密码格式错误
        (0, _util.clickDot)({
            buttonType: 'register_password_format_error_front',
            objectType: 'input_box'
        });
        return false;
    }
}

var timer = null;
var id = 0;

function getIframeName() {
    id += 1;
    return 'xman_post_iframe_' + id;
}

/**
 * 发送注册的post请求
 * @param {string} url
 * @param {*} data
 */
function sendPost(url, data, ncData, nCf, member) {
    return new Promise(function (resolve) {
        clearTimeout(timer);
        timer = setTimeout(function () {
            clear();
            resolve();
            _zoroArms2.default.error(new Error(url + ' timeout ' + member));
        }, 10000);

        var iframe = document.createElement('iframe');
        var name = getIframeName();
        var state = 0;
        var onLoad = function onLoad() {
            if (state === 1) {
                getData();
            } else if (state === 0) {
                state = 1;
                if (document.domain === 'aliexpress.com') {
                    iframe.contentWindow.location.href = '//page.aliexpress.com/join-proxy.htm';
                } else {
                    iframe.contentWindow.location.href = 'about:blank';
                }
            }
        };
        document.body.appendChild(iframe);
        iframe.style.display = 'none';
        iframe.contentWindow.name = name;
        var form = document.createElement('form');
        form.target = name;
        form.action = url;
        form.method = 'POST';
        form.id = 'ws-join-form-' + new Date().getTime();
        document.body.appendChild(form);

        function clear() {
            clearTimeout(timer);
            try {
                iframe.contentWindow.document.write('');
                iframe.contentWindow.close();
                document.body.removeChild(iframe);
                document.body.removeChild(form);
                onLoad = function onLoad() {};
            } catch (e) {}
        }

        function getData() {
            var da = '';
            try {
                da = JSON.parse(iframe.contentWindow.name);
            } catch (e) {
                _zoroArms2.default.error(e);
            }
            clear();
            resolve(da);
        }

        // repeat for each parameter
        data = data || {};

        if (ncData) {
            data.csessionid = ncData.csessionid;
            data.sig = ncData.sig;
        }

        data.ua = nCf ? nCf.getUA() : '';
        data.umidToken = nCf ? nCf.getUmidToken() : '';

        var input = void 0;
        for (var key in data) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        form.submit();
        iframe.onload = onLoad;
    });
}